import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import OverallCTRBarChart from './OverallCTRBarChart';
import '../../../../../styles/components/charts/pieChartComponent.scss';
import IndividualCTRBarChart from './IndividualCTRBarChart';
import ChartWithConfig from '../../../../../components/charts/ChartWithConfig';
import {
  addToCartButtonElement_CTR_DummyData,
  clickThroughRateDummyData,
  goToCheckoutButtonElement_CTR_DummyData,
  payButtonElement_CTR_DummyData,
} from '../../../../../lib/constants/graphDummyData/clickThroughRateDummyData';

const MainCTRChart = () => {
  const { t } = useTranslation();
  const [params, setParams] = useState<string>(
    '?graph_type=ctr_graph&group_by=overall'
  );
  const [selectedElement, setSelectedElement] = useState<string>('');
  const [response, setResponse] = useState<any>('initial');
  const [isBackButtonVisible, setIsBackButtonVisible] =
    useState<boolean>(false);

  const [comment, setComment] = useState<string>(t('OverallClickThroughRate'));

  const getIndividualCTRData = (element: string) => {
    if (element === 'addToCartButtonElement') {
      return addToCartButtonElement_CTR_DummyData;
    } else if (element === 'goToCheckoutButtonElement') {
      return goToCheckoutButtonElement_CTR_DummyData;
    } else if (element === 'payButtonElement') {
      return payButtonElement_CTR_DummyData;
    } else {
      return [];
    }
  };

  /* ---------API CALL----------- */
  const getGraphData = async () => {
    if (selectedElement !== '') {
      setResponse({
        type: 'individual',
        data: getIndividualCTRData(selectedElement),
      });
    } else {
      setResponse({ type: 'overall', data: clickThroughRateDummyData });
    }
  };

  useEffect(() => {
    setResponse('initial');
    if (selectedElement === '') {
      setParams(`?graph_type=ctr_graph&group_by=overall`);
      setComment(t('OverallClickThroughRate'));
    } else if (selectedElement !== '') {
      setParams(
        `?graph_type=ctr_graph&group_by=individual&group_by_value=${selectedElement}`
      );
      setComment(`${t('ClickThroughRateOf')} ${selectedElement}`);
    }
  }, [selectedElement]);

  useEffect(() => {
    getGraphData();
  }, [params]);

  const onBackButtonClick = () => {
    if (selectedElement !== '') {
      setSelectedElement('');
    }
  };

  useEffect(() => {
    if (selectedElement !== '') {
      setIsBackButtonVisible(true);
    } else {
      setIsBackButtonVisible(false);
    }
  }, [selectedElement]);

  function renderChart() {
    if (selectedElement === '') {
      return (
        <OverallCTRBarChart
          apiResponse={response}
          setSelectedElement={setSelectedElement}
        />
      );
    } else {
      return <IndividualCTRBarChart apiResponse={response} />;
    }
  }

  return (
    <ChartWithConfig
      title={t('ClickThroughRate')}
      comment={comment}
      onBackButtonClick={onBackButtonClick}
      isBackButtonVisible={isBackButtonVisible}
      isConfigHidden={true}
    >
      {renderChart()}
    </ChartWithConfig>
  );
};

export default MainCTRChart;
